import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from "@angular/core";
import { TooltipPosition } from "@angular/material/tooltip";
import { MatMenuTrigger } from "@angular/material/menu";
import { OptionMenuItem } from "../../download-upload.types";

@Component({
  selector: "app-driveb-option-menu",
  templateUrl: "./option-menu.component.html",
  styleUrls: ["./option-menu.component.scss"],
  standalone: false
})
export class OptionMenuComponent<T> {
  @Input() options: OptionMenuItem<T>[];
  @Input() positionTooltip: TooltipPosition = "right";
  @Input() tooltip: string;
  @Input() fontIcon: string;
  @Input() disabled = false;
  @Input() uploadButtonText: string;
  @Output() onClickItem = new EventEmitter<OptionMenuItem<T>>();
  @ViewChild("menuTrigger", { static: false }) menuTrigger: MatMenuTrigger;

  constructor() {}

  handleClickIconButton(event: Event) {
    event.stopPropagation();
    if (this.options.length > 1) {
      this.menuTrigger.openMenu();
      return;
    }
    this.onClickItem.emit(this.options[0]);
  }

  handleClickMenuOption(option: OptionMenuItem<T>) {
    this.onClickItem.emit(option);
  }
}
